import PageFooter from './PageFooter.vue'

export default PageFooter